export default [
    {
        path: '/settings/staffs',
        name: 'api.staff.create',
    },
    {
        path: '/settings/staffs/:staffid',
        name: 'api.staff.update',
    },
    {
        path: '/teams',
        name: 'api.teams',
    },
    {
        path: '/profiles',
        name: 'api.profiles',
    },
];
